import { RGBA } from './types';

export const RGBA_OBJ_WHITE: RGBA = {
  get red(): number {
    return 255;
  },
  get green(): number {
    return 255;
  },
  get blue(): number {
    return 255;
  },
  get alpha(): number {
    return 1;
  },
};

export const COLOR_NAME_TO_RGBA_MAP: Map<string, RGBA> = new Map([
  ['black', { red: 0, green: 0, blue: 0, alpha: 1 }],
  ['blue', { red: 0, green: 0, blue: 255, alpha: 1 }],
  ['darkblue', { red: 0, green: 0, blue: 139, alpha: 1 }],
  ['gray', { red: 128, green: 128, blue: 128, alpha: 1 }],
  ['green', { red: 0, green: 128, blue: 0, alpha: 1 }],
  ['magenta', { red: 255, green: 0, blue: 255, alpha: 1 }],
  ['orange', { red: 255, green: 165, blue: 0, alpha: 1 }],
  ['red', { red: 255, green: 0, blue: 0, alpha: 1 }],
  ['yellow', { red: 255, green: 255, blue: 0, alpha: 1 }],
]);
